import {
  WalletProviderPriority,
  getCore,
  getDefaultClient,
  getWalletProviderRegistry,
  hasExtension,
  registerExtension,
} from '@dynamic-labs-sdk/client/core';
import starknetCore from '@starknet-io/get-starknet-core';

import { registerStarknetNetworkProviderBuilder } from '../../registerStarknetNetworkProviderBuilder';
import { createWalletProviderFromStarknetWallet } from '../utils/createWalletProviderFromStarknetWallet';

export const STARKNET_INJECTED_WALLETS_EXTENSION_KEY =
  'starknetInjectedWallets';

/**
 * Adds the Starknet Injected Wallets extension to the Dynamic client.
 *
 * This extension enables integration with many Starknet wallets, like Braavos, Ready and Xverse.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 */
export const addStarknetInjectedWalletsExtension = (
  client = getDefaultClient()
): void => {
  if (
    hasExtension(
      { extensionKey: STARKNET_INJECTED_WALLETS_EXTENSION_KEY },
      client
    )
  ) {
    return;
  }

  registerExtension(
    { extensionKey: STARKNET_INJECTED_WALLETS_EXTENSION_KEY },
    client
  );

  registerStarknetNetworkProviderBuilder(client);

  const walletProviderRegistry = getWalletProviderRegistry(client);

  starknetCore
    .getAvailableWallets()
    .then((starknetWindowProviders) => {
      starknetWindowProviders.forEach((starknetWindowProvider) => {
        const walletProvider = createWalletProviderFromStarknetWallet({
          dynamicClient: client,
          starknetWindowProvider,
        });

        walletProviderRegistry.register({
          priority: WalletProviderPriority.WINDOW_INJECT,
          walletProvider,
        });
      });
    })
    .catch((error) => {
      getCore(client).logger.error(
        'Error getting available starknet wallets',
        error
      );
    });
};
